import { PaypalAction, PaypalActionType } from '../actions/paypal';
import { PaypalNamespace, PaypalScriptStatus } from '../state/paypal';

export const paypalReducer = (
    state: PaypalNamespace = {
        isMakingPaypalPayment: false,
        scriptStatus: PaypalScriptStatus.init,
    },
    action: PaypalAction,
): PaypalNamespace => {
    switch (action.type) {
        case PaypalActionType.setIsMakingPaypalPayment:
            return {
                ...state,
                isMakingPaypalPayment: action.payload,
            };
        case PaypalActionType.setScriptStatus:
            return {
                ...state,
                scriptStatus: action.payload.scriptStatus,
            };
        default:
            return state;
    }
};
